import get from 'lodash/get';

export const gon = (path: string) => get(global.gon, path);
